<template>
    <div v-if="invoice" class="card mb-4">
        <div class="card-body">
            <h2 class="h4 mb-3">
                {{ invoice.order_label }} #{{ invoice.order_number }}
            </h2>

            <div class="row mb-3">
                <div class="col-sm-6">
                    <div class="text-muted">{{ $t('Dato') }}</div>
                    <strong>{{ invoice.order_date }}</strong>
                </div>
                <div class="col-sm-6">
                    <div class="text-muted">{{ $t('Forfallsdato') }}</div>
                    <strong>{{ invoice.order_due_date }}</strong>
                </div>
            </div>

            <h3 class="h5">{{ $t('Fakturalinjer') }}</h3>
            <div class="table-responsive">
                <table class="table mb-0">
                    <thead>
                    <tr>
                        <th>{{ $t('Beskrivelse') }}</th>
                        <th class="text-end">{{ $t('Antall') }}</th>
                        <th class="text-end">{{ $t('Beløp') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(line, index) in invoice.lines" :key="line.id || index">
                        <td>
                            {{ line.description || line.description2 }}
                            <div v-if="line.description && line.description2" class="text-muted small">
                                {{ line.description2 }}
                            </div>
                        </td>
                        <td class="text-end">{{ line.quantity }}</td>
                        <td class="text-end text-nowrap">{{ line.amount_formatted }}</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th colspan="2">{{ $t('Totalt beløp') }}</th>
                        <th class="text-end text-nowrap">{{ invoice.amount_formatted }}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>

            <div class="row mt-3">
                <div class="col-sm-4">
                    <div class="text-muted">{{ $t('Totalt') }}</div>
                    <strong>{{ invoice.amount_formatted }}</strong>
                </div>
                <div class="col-sm-4">
                    <div class="text-muted">{{ $t('Innbetalt') }}</div>
                    <strong>{{ invoice.paid_amount_formatted }}</strong>
                </div>
                <div class="col-sm-4">
                    <div class="text-muted">{{ $t('Gjenstår') }}</div>
                    <strong>{{ invoice.amount_due_formatted }}</strong>
                </div>
            </div>

            <div v-if="invoice.payments.length" class="mt-4">
                <h3 class="h5">{{ $t('Innbetalinger') }}</h3>
                <table class="table mb-0">
                    <thead>
                    <tr>
                        <th>{{ $t('Dato') }}</th>
                        <th class="text-end">{{ $t('Beløp') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(payment, index) in invoice.payments" :key="payment.id || index">
                        <td>{{ payment.date }}</td>
                        <td class="text-end text-nowrap">{{ payment.amount_formatted }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import Store from '../../state/paymentStore'

const invoice = computed(() => Store.getAccountOrderHistory())
</script>
